import { PreloadingStrategy, Route } from "@angular/router"
import { Observable, of, from } from "rxjs"
import { Injectable } from "@angular/core"
import { SessionService } from "src/services/session-service"
import { switchMap } from "rxjs/operators"

// Allows us to use preloading for lazy loaded routes
// Doesn't affect initial load time, but loads "important" feature modules in the background

// USAGE:
// When creating a lazy loaded route, after loadChildren, specify data: { preload: true } to preload important routes
// Alternatively you can provide roles for which modules should preload either as an array of roles or a single role as a string
// Example:
// data: { preload: 'writer' }
// data: { preload: 'customer' },
// data: { preload: ['customer', 'admin'] }

@Injectable({providedIn: 'root'})
export class AppPreloadingStrategy implements PreloadingStrategy {
  constructor(private sessionService: SessionService) {}

  preload(route: Route, load: Function): Observable<any> {
    return from(this.sessionService.currentRole()).pipe(
      switchMap(currentRole => {
        const preload = route.data && route.data.preload
        if (
          preload === true ||
          typeof preload === 'string' && preload === currentRole ||
          typeof preload === 'object' && preload.includes(currentRole)
        ) return load()
        else return of(null)
      })
    )
  }
}
